// @flow

const routes = {
  signUp: '/',
  signIn: '/sign-in',
  recoverPassword: '/recover-password',
  changePassword: '/change-password',
  home: '/home',
  profile: '/profile',
  process: '/process',
  contract: '/contract',
  selfie: '/selfie',
  links: '/links',
  payment: '/payment',
  validation: '/validation',
  contractValidation: '/contract-validation',
};

export default routes;
